import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

const mainCategories = categories.filter((c) => !["all", "completed"].includes(c.slug));

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-600 mt-1">找到你喜欢的漫画类型</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-8 gap-3 md:gap-4">
          {mainCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-100 hover:bg-primary-50 cursor-pointer transition-colors group"
            >
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-lg text-accent-700`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}